import type { PropsWithChildren } from 'react';

import { Translate, withI18nPlaceholders } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/starterDashboard/starter-dashboard.yml';

import type { StarterDashboardPageData } from 'src/app/pages/starterDashboard/pageContext';

import { DownloadFlyerModalBodyLoader as DownloadFlyerModalBody } from './components/DownloadFlyerModalBodyLoader';

type Context = 'starter_dashboard_task' | 'starter_dashboard_grow_petition';
type Petition = StarterDashboardPageData['petition'];

const PlaceholdersProvider = withI18nPlaceholders(I18N_PLACEHOLDERS, ({ children }: PropsWithChildren) => (
	<>{children}</>
));

export const useDownloadFlyerModal = createModalHook<{ petition: Petition; context: Context }>({
	name: 'DownloadFlyerModal',
	heading: () => (
		<Flex mr={28}>
			<Heading breakWord as="h1" size="h3" data-qa="download-flyer-modal-heading">
				<Translate value="corgi.petition.starter_dashboard.shared.flyer.multi_modal_heading" />
			</Heading>
		</Flex>
	),
	body: function DownloadFlyerModal({ options: { petition, context } }) {
		return <DownloadFlyerModalBody petition={petition} context={context} />;
	},
	decorator: ({ children }) => <PlaceholdersProvider>{children}</PlaceholdersProvider>,
	stylesOverrides: {
		width: 'calc(100% - 32px)',
		minWidth: [null, 600],
		maxWidth: [400, 640],
	},
});
